module.exports = __webpack_public_path__ + "static/img/image_title@2x.bb057f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktb/image_title@2x.png
// module id = gnTB
// module chunks = 69